import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CompanyRow,
    WB_CurrencyRow,
    WB_CustomerRow, WB_MasterDataSetRow,
    WB_PeriodRow, WB_PlanRow,
    WB_ProductGroupRow,
    WB_Snapshot_TypeRow,
    WB_SnapshotCustomerRelationshipRow,
    WB_SnapshotPeriodRelationshipRow, WB_SnapshotPlanRelationshipRow,
    WB_SnapshotProductGroupRelationshipRow,
    WB_SnapshotRow,
    WB_WorkflowStatusRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbSnapshot} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Company, esWB_Currency,
    esWB_Customer, esWB_MasterData_Set, esWB_Period, esWB_Plan, esWB_Product_Group,
    esWB_Snapshot,
    esWB_Snapshot_Customer_Relationship,
    esWB_Snapshot_Period_Relationship, esWB_Snapshot_Plan_Relationship,
    esWB_Snapshot_ProductGroup_Relationship,
    esWB_Snapshot_Type,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {IHaveWorkflow, IWorkflowProcessor} from "../PA.Core/PA.Core.IF.Workflow";
import {WorkflowProcessor} from "../PA.Core/Workflow/WorkflowProcessor";
import {WorkflowStatusService} from "../PA.MD.Services/WorkflowStatusService";
import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicyCollection} from "../PA.Core/PA.Core.IF.Policy";
import {PolicyCollection} from "../PA.Core/Security/PolicyCollection";
import {PolicyBOis} from "../PA.Core/Security/PolicyBOis";
import {PolicyHasRole} from "../PA.Core/Security/PolicyHasRole";
import {IHaveSecurity} from "../PA.Core/PA.Core.IF.Aspects";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {SnapshotBOValidations} from "./SnapshotBO.Validations";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {SnapshotTypeService} from "../PA.MD.Services/SnapshotTypeService";
import {MDUsageService} from "../PA.MD.Services/MDUsageService";

export interface ISnapshotSaveValidateOptions {
    Validate?: {
        bSkipAllValidations?: boolean
    },
    Save?: {}
}

const SnapshotSaveValidateOptions_default: ISnapshotSaveValidateOptions = {
    Validate: {
        bSkipAllValidations: false
    },
    Save: {}
}

export class SnapshotBO implements IBusinessObject,
    IHaveWorkflow,
    IHaveSecurity {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    _bIsLoadedInternal: boolean;
    _OnLoadCompleteInternal: Promise<SnapshotBO>
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Snapshot: WB_SnapshotRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Snapshot'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this._OnLoadComplete = undefined
        this._OnLoadCompleteInternal = undefined
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Snapshot = null;

        this.IHaveSecurity_init()
        this.IHaveWorkflow_init()

    }

    get WB_Snapshot(): WB_SnapshotRow {
        return this.drWB_Snapshot;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Snapshot");
        let createOpts = _.defaultsDeep({}, self.CreateOptions, options)
        this._OnLoadCompleteInternal
            = new Promise<SnapshotBO>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Snapshot.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Snapshot)
                .then((newSnapshotRow: WB_SnapshotRow) => {
                    newSnapshotRow.setDefaults()
                    self.drWB_Snapshot = newSnapshotRow;
                    self.dbContext.add(esWB_Snapshot, newSnapshotRow)
                    self.Identity.setAll(self.WB_Snapshot.cif.WB_SNAPSHOT_ID, self.WB_Snapshot.cif.SNAPSHOT_ID, self.WB_Snapshot.cif.SNAPSHOT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Snapshot, 'WB_SNAPSHOT_ID', 'SNAPSHOT_ID', 'SNAPSHOT_NAME')

                    self.drWB_Snapshot.cif.WB_SNAPSHOTM_ID = createOpts.SnapshotTypeId
                    self.drWB_Snapshot.cif.SNAPSHOT_NAME = createOpts.SnapshotName
                    self.drWB_Snapshot.cif.AUTO_RUN_ENABLE_IND = '0'


                    return SnapshotTypeService.getSnapshotMByWbID(self.drWB_Snapshot.cif.WB_SNAPSHOTM_ID)
                })
                .then((aSnapshotType: WB_Snapshot_TypeRow) => {
                    self.drWB_Snapshot.WB_SnapshotTypeRow = aSnapshotType
                    return self.dbContext.find(esWB_MasterData_Set, self.drWB_Snapshot.WB_SnapshotTypeRow.cif.WB_MDSET_ID)
                })
                .then((aMDSetRow: WB_MasterDataSetRow) => {
                    self.drWB_Snapshot.cif.WB_MDSET_ID = aMDSetRow.cif.WB_MDSET_ID
                    self.drWB_Snapshot.WB_SnapshotTypeRow.WB_MasterDataSetRow = aMDSetRow
                    return self.dbContext.find(esWB_Company, self.drWB_Snapshot.WB_SnapshotTypeRow.cif.WB_COMPANY_ID)
                })
                .then((aCompanyRow: WB_CompanyRow) => {
                    self.drWB_Snapshot.WB_SnapshotTypeRow.WB_CompanyRow = aCompanyRow

                    self.drWB_Snapshot.cif.AUTO_RUN_ENABLE_IND = self.drWB_Snapshot.WB_SnapshotTypeRow.cif.AUTO_RUN_IND || '0'
                    return WorkflowStatusService.getInitialWorkflowStatusByWorkflowWbID(self.WB_Snapshot.WB_SnapshotTypeRow.cif.WB_WORKFLOW_ID)
                   }).then((aWorkflowStatus: WB_WorkflowStatusRow) => {
                if (!_.isEmpty(aWorkflowStatus)) {
                    self.drWB_Snapshot.cif.WORKFLOW_STATUS_ID = aWorkflowStatus.cif.WB_STATUS_ID
                    self.drWB_Snapshot.cif.WORKFLOW_STATUS_ID_NEXT = self.drWB_Snapshot.cif.WORKFLOW_STATUS_ID
                }
                if (self.drWB_Snapshot.WB_SnapshotTypeRow.WB_CompanyRow?.cif?.WB_CURRENCY_ID== 0 || self.drWB_Snapshot.WB_SnapshotTypeRow.WB_CompanyRow?.cif?.WB_CURRENCY_ID==undefined) {
                    resolve(self)
                    return
                }
                return self.dbContext.find(esWB_Currency, self.drWB_Snapshot.WB_SnapshotTypeRow.WB_CompanyRow?.cif?.WB_CURRENCY_ID)
            }).then((currency: WB_CurrencyRow) => {
                self.drWB_Snapshot.WB_SnapshotTypeRow.WB_CompanyRow.WB_CurrencyRow = currency
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self._OnLoadCompleteInternal
                .then((aBO) => {
                    if (self.bIsLoaded) {
                        resolve(self)
                        return;
                    }

                    // Run after Load
                    self._bIsLoadedInternal = true
                    self._OnLoadCompleteInternal = undefined
                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self)
                })
        })

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        self._OnLoadCompleteInternal = new Promise<SnapshotBO>((resolve, error) => {
            if (self.bIsLoaded) {
                resolve(self); // "Snapshot already loaded.";
                return;
            }

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for new Snapshot.")
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = SnapshotBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = SnapshotBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let aSnapshotRow: any = recordResolver.get(esWB_Snapshot, anId)

                    if (_.isEmpty(aSnapshotRow)) {
                        console.log("Snapshot Record Resolver unable to locate Snapshot for id: ", anId)
                        error("Snapshot not Found");
                        return;
                    }

                    self.drWB_Snapshot = aSnapshotRow;
                    self.Identity.setAll(self.WB_Snapshot.cif.WB_SNAPSHOT_ID, self.WB_Snapshot.cif.SNAPSHOT_ID, self.WB_Snapshot.cif.SNAPSHOT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Snapshot, 'WB_SNAPSHOT_ID', 'SNAPSHOT_ID', 'SNAPSHOT_NAME')

                    resolve(self)
                })
                .catch(function (err: any) {
                    error(err)
                    return;
                });

        })

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self._OnLoadCompleteInternal
                .then((aBO) => {
                    if (self.bIsLoaded) {
                        resolve(self)
                        return;
                    }

                    // Run after Load
                    self._bIsLoadedInternal = true
                    self._OnLoadCompleteInternal = undefined
                    self._AfterBoLoadCompleteInternal()
                        .then(() => {
                            self._bIsLoaded = true;
                            self._OnLoadComplete = undefined
                            self.LoadProgressProvider.finish()

                            resolve(self)
                        })
                        .catch((err) => {
                            self._OnLoadCompleteInternal = undefined;
                            self._OnLoadComplete = undefined;
                            self.LoadProgressProvider.exception(err);
                            resolve(err)
                        })
                })
                .catch((err) => {
                    self._OnLoadCompleteInternal = undefined;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    resolve(self)
                })
        })

        return this._OnLoadComplete;
    }

    _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            let tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('SnapshotBO.PostLoad', 'Processing Loaded Data');
            tasks.push(self.IHaveSecurity_OnLoadComplete())
            let mruService = new MDUsageService()
            if (_.isNumber(self.WB_Snapshot.WB_SnapshotParamRow?.cif.WB_MDSET_ID) && self.WB_Snapshot.WB_SnapshotParamRow?.cif.WB_MDSET_ID > 0) {
                tasks.push(mruService.saveMDSetUsage(self.WB_Snapshot.WB_SnapshotParamRow.cif.WB_MDSET_ID))
            }
            if (_.isNumber(self.WB_Snapshot.WB_SnapshotParamRow?.cif.WB_COMPANY_ID) && self.WB_Snapshot.WB_SnapshotParamRow?.cif.WB_COMPANY_ID > 0) {
                tasks.push(mruService.saveCompanyUsage(self.WB_Snapshot.WB_SnapshotParamRow.cif.WB_COMPANY_ID))
            }
            if (_.isNumber(self.WB_Snapshot.cif.WB_SALESORG_ID) && self.WB_Snapshot.cif.WB_SALESORG_ID > 0) {
                tasks.push(mruService.saveSalesOrgUsage(self.WB_Snapshot.cif.WB_SALESORG_ID))
            }
            if (_.isNumber(self.WB_Snapshot.cif.WB_SALESAREA_ID) && self.WB_Snapshot.cif.WB_SALESAREA_ID > 0) {
                tasks.push(mruService.saveSalesAreaUsage(self.WB_Snapshot.cif.WB_SALESAREA_ID))
            }

            Promise.all(tasks)
                .then((results: any) => {
                    if (self.drWB_Snapshot.WB_SnapshotTypeRow?.cif.WB_WORKFLOW_ID > 0)
                        return self.IHaveWorkflow_OnLoadComplete()
                    else
                        resolve();
                })
                .then((ignore) => {
                    resolve();
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: ISnapshotSaveValidateOptions): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Snapshot.cif.SNAPSHOT_NAME + "(" + self.WB_Snapshot.cif.WB_SNAPSHOT_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            options = options || {}
            _.defaultsDeep(options, SnapshotSaveValidateOptions_default)

            self.ValidateOptions = options;

            if (self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Snapshot.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            async function RunSnapshotBOValidate() {

                await SnapshotBOValidations.Validate(self)

                if (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0) {

                    for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                        let aWfProcessor = self.WorkflowProcessors[idx]
                        await aWfProcessor.Validate()
                        self.ValidateMessageProvider.addMessages(aWfProcessor.WorkflowMessageProvider.Messages)
                    }
                }

                if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                    self._bIsValidated = false;
                } else {
                    self._bIsValidated = true;
                }
                self.ValidateProgressProvider.finish();
            }

            RunSnapshotBOValidate()
                .then((ignore) => {
                    resolve(self);
                })
                .catch((err) => {
                    self._bIsValidated = false;
                    self.ValidateProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbSnapshot = <IwbSnapshot>self.drWB_Snapshot;
        this.SaveProgressProvider.start("Saving " + wbSnapshot.SNAPSHOT_NAME + "(" + wbSnapshot.WB_SNAPSHOT_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Snapshot.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            options = options || {}
            _.defaultsDeep(options, SnapshotSaveValidateOptions_default)
            self.SaveOptions = options

            var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }
            self.SaveProgressProvider.setPercentComplete(0.1)
            let validatePromise = undefined
            if (options.Validate.bSkipAllValidations) {
                validatePromise = ASync.resolve(self)
                self._bIsValidated = true
            } else {
                validatePromise = self.Validate(options)
            }

            validatePromise
                .then((ignored) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return
                    }
                    let tasks: Promise<any>[] = []

                    tasks.push(saveFunction(esWB_Snapshot, self.drWB_Snapshot))
                    tasks.push(saveFunction(esWB_Snapshot_Customer_Relationship, self.drWB_Snapshot.WB_SnapshotCustomerRelationshipRows))
                    tasks.push(saveFunction(esWB_Snapshot_Period_Relationship, self.drWB_Snapshot.WB_SnapshotPeriodRelationshipRows))
                    tasks.push(saveFunction(esWB_Snapshot_ProductGroup_Relationship, self.drWB_Snapshot.WB_SnapshotProductGroupRelationshipRows))
                    tasks.push(saveFunction(esWB_Snapshot_Plan_Relationship, self.drWB_Snapshot.WB_SnapshotPlanRelationshipRows))

                    return Promise.all(tasks)
                }).then((ignored) => {
                if (!self.bIsValidated) {
                    return
                }

                async function RunWorkflowSaveFunctions() {

                    for (let idx = 0; idx < self.WorkflowProcessors.length; idx++) {
                        let aWfProcessor = self.WorkflowProcessors[idx]
                        await aWfProcessor.Save(bBatch)
                    }
                }

                return RunWorkflowSaveFunctions()
            })
                .then((ignored) => {
                    if (!self.bIsValidated) {
                        return
                    }
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbSnapshot = <IwbSnapshot>self.drWB_Snapshot;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbSnapshot.SNAPSHOT_NAME + "(" + wbSnapshot.WB_SNAPSHOT_ID + ")");
        return new Promise<IBusinessObject>((resolve, error) => {
            // 1. Validate if we can delete the Snapshot
            SnapshotBOValidations.ValidateBeforeDelete(self)
                .then((ignore) => {
                    if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                        this.DeleteProgressProvider.finish();
                        resolve(self)
                        return;
                    }

                    self.drWB_Snapshot.markDeleted()
                    _.forEach(self.drWB_Snapshot.WB_SnapshotPlanRelationshipRows, (a) => a.markDeleted())
                    _.forEach(self.drWB_Snapshot.WB_SnapshotProductGroupRelationshipRows, (a) => a.markDeleted())
                    _.forEach(self.drWB_Snapshot.WB_SnapshotPeriodRelationshipRows, (a) => a.markDeleted())
                    _.forEach(self.drWB_Snapshot.WB_SnapshotCustomerRelationshipRows, (a) => a.markDeleted())

                    return self.SaveUsing(false, {Validate: {bSkipAllValidations: true}})
                })
                .then((ignore) => {
                    if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                        return
                    }
                    self._bIsDeleted = true;
                })
                .then((ignore) => {
                    self.DeleteProgressProvider.finish();
                    self.SaveProgressProvider.finish()
                    resolve(self);
                })
                .catch((err) => {
                    this.DeleteProgressProvider.exception(err)
                    resolve(self)
                })
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveWorkflow operations">

    private _WorkflowProcessors: IWorkflowProcessor[]
    private _PrimaryWorkflowProcessor: IWorkflowProcessor


    private IHaveWorkflow_init(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    private IHaveWorkflow_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            // Reset Workflow Processors

            self._WorkflowProcessors = []

            let aWorkflowProcessor
                = new WorkflowProcessor(self.WB_Snapshot.WB_SnapshotTypeRow.cif.WB_WORKFLOW_ID,
                {
                    dbContext: self.dbContext,
                    AppMgr_Id: 'Snapshot',
                    WB_App_Id: self.WB_Snapshot.cif.WB_SNAPSHOT_ID,
                    App_Id: self.WB_Snapshot.cif.SNAPSHOT_ID,
                    bLoadWorkflowHistory: true,
                    bLoadUserReviewers: false,
                    object: self,
                    Record: self.WB_Snapshot,
                    CurrentStateIdFieldName: 'WORKFLOW_STATUS_ID',
                    NextStateIdFieldName: 'WORKFLOW_STATUS_ID_NEXT',
                    NextUserIdFieldName: 'WB_AUTHUSR_ID_WF_NEXT',
                    OwnerUserIdFieldName: 'WB_AUTHUSR_ID_CREATEDBY'
                })
            aWorkflowProcessor.setPolicyFields({
                    WorkflowVisible: true,
                    CurrentStateVisible: true,
                    NextStateVisible: true,
                    NextStateEditable: true
                }
            )
            self._PrimaryWorkflowProcessor = aWorkflowProcessor

            self.PolicyCollection.addPolicy("Workflow", aWorkflowProcessor)

            aWorkflowProcessor.OnLoadComplete
                .then((ignore) => {
                    self._WorkflowProcessors.push(aWorkflowProcessor)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    private IHaveWorkflow_BeforeReload(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    get WorkflowProcessors(): IWorkflowProcessor[] {
        return this._WorkflowProcessors
    }

    get PrimaryWorkflowProcessor(): IWorkflowProcessor {
        return this._PrimaryWorkflowProcessor
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_BeforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aBOis = new PolicyBOis(['Super_User', 'Snapshot_Editor', 'Snapshot_Generator'], ['Snapshot_Viewer'])
        self.PolicyCollection.addPolicy("BOis", aBOis)

        let aHasRolePolicy: PolicyHasRole

        this._OnIHaveSecurityLoaded = new Promise<IHaveSecurity>((resolve, error) => {
            aHasRolePolicy = new PolicyHasRole()
            aHasRolePolicy.OnLoadComplete
                .then((ignore) => {
                    self.PolicyCollection.addPolicy("HasRole", aHasRolePolicy)
                    this._bIHaveSecurityLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolverProvider   <<STATIC>> operations">

    addCustomerR(aWbCustId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false
            _.forEach(self.drWB_Snapshot.WB_SnapshotCustomerRelationshipRows, (aSnapshotCustomerRelRow: WB_SnapshotCustomerRelationshipRow) => {
                if (aSnapshotCustomerRelRow.isActive && aSnapshotCustomerRelRow.cif.WB_CUST_ID == aWbCustId) {
                    found = true
                    return false
                }
            })

            if (found) {
                resolve(self);
                return
            } // exists..
            var aCustomerRow: WB_CustomerRow = undefined

            self.dbContext.find(esWB_Customer, aWbCustId)
                .then((aCustomerRecord: WB_CustomerRow) => {
                    if (_.isEmpty(aCustomerRecord)) {
                        // Bad Customer ID
                        resolve(self)
                        return
                    }
                    aCustomerRow = aCustomerRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Snapshot_Customer_Relationship)
                })
                .then((aNewRow: WB_SnapshotCustomerRelationshipRow) => {

                    // anUserGroupCustomerRow = aNewRow
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SNAPSHOT_ID = self.drWB_Snapshot.cif.WB_SNAPSHOT_ID
                    aNewRow.cif.WB_CUST_ID = aWbCustId
                    aNewRow.WB_CustomerRow = aCustomerRow
                    self.dbContext.add(esWB_Snapshot_Customer_Relationship, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    deleteCustomerR(aWbSnapCustRId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Snapshot.WB_SnapshotCustomerRelationshipRows, (aSnapshotCustomerRelRow: WB_SnapshotCustomerRelationshipRow) => {
                if (aSnapshotCustomerRelRow.isActive && aSnapshotCustomerRelRow.cif.WB_SNAPSHOT_CUSTR_ID == aWbSnapCustRId) {
                    aSnapshotCustomerRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    addProductGroupR(aWbPgId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false
            _.forEach(self.drWB_Snapshot.WB_SnapshotProductGroupRelationshipRows, (aSnapshotPGRelRow: WB_SnapshotProductGroupRelationshipRow) => {
                if (aSnapshotPGRelRow.isActive && aSnapshotPGRelRow.cif.WB_CUST_ID == aWbPgId) {
                    found = true
                    return false
                }
            })

            if (found) {
                resolve(self);
                return
            } // exists..
            var aPGRow: WB_ProductGroupRow = undefined

            self.dbContext.find(esWB_Product_Group, aWbPgId)
                .then((aPGRecord: WB_ProductGroupRow) => {
                    if (_.isEmpty(aPGRecord)) {
                        resolve(self)
                        return
                    }
                    aPGRow = aPGRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Snapshot_ProductGroup_Relationship)
                })
                .then((aNewRow: WB_SnapshotProductGroupRelationshipRow) => {

                    // anUserGroupCustomerRow = aNewRow
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SNAPSHOT_ID = self.drWB_Snapshot.cif.WB_SNAPSHOT_ID
                    aNewRow.cif.WB_PRDGRP_ID = aWbPgId
                    aNewRow.WB_ProductGroupRow = aPGRow
                    self.dbContext.add(esWB_Snapshot_ProductGroup_Relationship, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    deleteProductGroupR(aWbSnapPgId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Snapshot.WB_SnapshotProductGroupRelationshipRows, (aSnapshotPGRelRow: WB_SnapshotProductGroupRelationshipRow) => {
                if (aSnapshotPGRelRow.isActive && aSnapshotPGRelRow.cif.WB_SNAPSHOT_PRDR_ID == aWbSnapPgId) {
                    aSnapshotPGRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    addPeriodR(aWbPId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false
            _.forEach(self.drWB_Snapshot.WB_SnapshotPeriodRelationshipRows, (aSnapshotPRelRow: WB_SnapshotPeriodRelationshipRow) => {
                if (aSnapshotPRelRow.isActive && aSnapshotPRelRow.cif.WB_PERIOD_ID == aWbPId) {
                    found = true
                    return false
                }
            })

            if (found) {
                resolve(self);
                return
            } // exists..
            var aPRow: WB_PeriodRow = undefined

            self.dbContext.find(esWB_Period, aWbPId)
                .then((aPRecord: WB_PeriodRow) => {
                    if (_.isEmpty(aPRecord)) {
                        resolve(self)
                        return
                    }
                    aPRow = aPRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Snapshot_Period_Relationship)
                })
                .then((aNewRow: WB_SnapshotPeriodRelationshipRow) => {

                    // anUserGroupCustomerRow = aNewRow
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SNAPSHOT_ID = self.drWB_Snapshot.cif.WB_SNAPSHOT_ID
                    aNewRow.cif.WB_PERIOD_ID = aWbPId
                    aNewRow.WB_PeriodRow = aPRow
                    self.dbContext.add(esWB_Snapshot_Period_Relationship, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    deletePeriodR(aWbSnapPId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Snapshot.WB_SnapshotPeriodRelationshipRows, (aSnapshotPRelRow: WB_SnapshotPeriodRelationshipRow) => {
                if (aSnapshotPRelRow.isActive && aSnapshotPRelRow.cif.WB_SNAPSHOT_PERIODR_ID == aWbSnapPId) {
                    aSnapshotPRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    addPlanR(aWbPlanId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false
            _.forEach(self.drWB_Snapshot.WB_SnapshotPlanRelationshipRows, (aSnapshotPlanRelRow: WB_SnapshotPlanRelationshipRow) => {
                if (aSnapshotPlanRelRow.isActive && aSnapshotPlanRelRow.cif.WB_PLAN_ID == aWbPlanId) {
                    found = true
                    return false
                }
            })

            if (found) {
                resolve(self);
                return
            } // exists..
            var aPlanRow: WB_PlanRow = undefined

            self.dbContext.find(esWB_Plan, aWbPlanId)
                .then((aPlanRecord: WB_PlanRow) => {
                    if (_.isEmpty(aPlanRecord)) {
                        // Bad Plan ID
                        resolve(self)
                        return
                    }
                    aPlanRow = aPlanRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Snapshot_Plan_Relationship)
                })
                .then((aNewRow: WB_SnapshotPlanRelationshipRow) => {

                    // anUserGroupCustomerRow = aNewRow
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SNAPSHOT_ID = self.drWB_Snapshot.cif.WB_SNAPSHOT_ID
                    aNewRow.cif.WB_PLAN_ID = aWbPlanId
                    aNewRow.WB_PlanRow = aPlanRow
                    self.dbContext.add(esWB_Snapshot_Plan_Relationship, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    deletePlanR(aWbSnapPlanId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Snapshot.WB_SnapshotPlanRelationshipRows, (aSnapshotPlanRelRow: WB_SnapshotPlanRelationshipRow) => {
                if (aSnapshotPlanRelRow.isActive && aSnapshotPlanRelRow.cif.WB_SNAPSHOT_PLANR_ID == aWbSnapPlanId) {
                    aSnapshotPlanRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts)
            dbContext = opts.dbContext;
        else {
            dbContext = new PAdbContext({});
        }
        const snapshot_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {
                [esWB_Snapshot_Type]: [esWB_Company, esWB_Currency]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, snapshot_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Snapshot, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })

    }

    static concurrentLoadCountHint(): number {
        return 5;
    }

//</editor-fold>

};


PAEnvironment.registerBusinessObjectClass(SnapshotBO, "SnapshotBO","Snapshot")
